// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__36K6Y","image":"styles_image__22tT6","title":"styles_title__1D1cG","subtitle":"styles_subtitle__NBBAI","button":"styles_button__2L3kw"};